import { SiteManager } from './SiteManager';
import { Finance } from './Finance';
import { InventoryManager } from './InventoryManager';
import { Consultant } from './Consultant';
import { RoleMatrix } from './types';
import { ProjectManager } from './ProjectManager';
import { HumanResource } from './HumanResource';
import { Procurement } from './Procurement';
import { Client } from './Client';
import { Contractor } from './Contractor';
import { ReadOnly } from './ReadOnly';

export const defaultPermissionMatrix: RoleMatrix = {
  "Project Manager": ProjectManager,
  "Site Manager": SiteManager,
  "Human Resource": HumanResource,
  "Procurement": Procurement,
  "Finance": Finance,
  "Inventory Manager": InventoryManager,
  "Consultant": Consultant,
  "Client": Client,
  "Contractor": Contractor,
  "Read Only": ReadOnly,
}; 